import React from 'react';

const TagPill = ({ label }) => (
  <span className="inline-flex items-center gap-1 text-[10px] text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full px-2 py-0.5">
    <svg className="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
    </svg>
    {label}
  </span>
);

const PersonBadge = () => (
  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-100 text-gray-400">
    <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
    </svg>
  </span>
);

const SeasonCard = React.memo(({ season }) => (
  <article className="shrink-0 w-[140px] sm:w-[160px] rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow">
    <div className="aspect-[4/3] overflow-hidden">
      <img
        src={season.imageUrl}
        alt={season.name}
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
    <div className="p-2.5">
      <h4 className="font-semibold text-gray-900 text-sm">{season.name}</h4>
      <p className="text-[11px] text-gray-400 mt-0.5">{season.months}</p>
      <div className="flex items-center gap-1.5 mt-2 flex-wrap">
        {season.tags.map((tag) => (
          <TagPill key={tag} label={tag} />
        ))}
        <PersonBadge />
      </div>
    </div>
  </article>
));

SeasonCard.displayName = 'SeasonCard';

export default SeasonCard;
